export default [
  {
    route: 'store-grocery-dashboard',
    title: 'store-grocery-dashboard',
    slug: 'dashboard',
    icon: 'HomeIcon',
    i18n: 'Dashboard',
    resource: 'Store-grocery-dashboard',
    action: 'read',
  },
]
